export type Shipper = {
  companyName: string
  email: string
  logoUrl?: string
  name?: string
  phoneNumber?: string
  id?: number
  isTest?: boolean
}

/**
 * @todo refactor this function because it will currently always return true
 */
export function hasShipperInformation(shipper: Shipper) {
  const { companyName, email, name, phoneNumber } = shipper
  return Boolean(companyName) || Boolean(email) || Boolean(name) || Boolean(phoneNumber)
}
